<div *ngIf="result?.additionalInfo?.location" class="d-flex align-items-center mt-1" style="gap: 0.25em; padding-left: 2em">
  <img src="../../../../../assets/icons/itinerary/lugar.svg" width="20px" height="20px" alt="" style="opacity: 0.5" />
  <p class="rubik-regular-12pt mb-0">{{ result.additionalInfo.location }}</p>
</div>

<div class="d-flex align-items-center mt-3 mb-2" style="gap: 0.5em; margin-left: 2em">
  <div
    *ngIf="category"
    class="d-flex align-items-center"
    style="height: 28px; border-radius: 50rem"
    [style.background-color]="category.background"
  >
    <p class="mb-0 px-4" style="font-family: &quot;Rubik&quot;; font-size: 13px; font-weight: 400" [style.color]="category.color">
      {{ category.label }}
    </p>
  </div>
  <div
    *ngIf="result?.additionalInfo?.availability?.boardName"
    class="d-flex align-items-center"
    style="height: 28px; background-color: #f0f0f0; border-radius: 50rem"
  >
    <p class="mb-0 px-3" style="font-family: &quot;Rubik&quot;; font-size: 13px; font-weight: 400; color: #000000">
      {{ result.additionalInfo.availability.boardName }}
    </p>
  </div>
</div>

<div class="d-flex flex-row w-100 mt-auto" style="height: 67px; border-top: 0.5px solid #cccccc; margin-top: 35px !important">
  <div class="item-info d-flex align-items-center justify-content-center px-2" style="width: 50%; gap: 0.5em; border-right: 0.5px solid #cccccc">
    <img src="../../../../../assets/icons/itinerary/cama_peq.svg" width="24px" height="24px" alt="" style="opacity: 0.5" />
    <div style="line-height: 12px">
      <p class="rubik-regular-12pt mb-0" style="font-weight: 600; color: black">{{ boat?.cabinCount || 0 }} cabinas</p>
      <p *ngIf="skipperIncluded" class="rubik-regular-12pt mb-0">(+1p/ Capitán)</p>
    </div>
  </div>
  <div class="item-info d-flex align-items-center justify-content-center px-2" style="width: 50%; gap: 0.5em">
    <img src="../../../../../assets/icons/search-result/persona.svg" width="24px" height="24px" alt="" style="opacity: 0.5" />
    <div style="line-height: 12px">
      <p class="rubik-regular-12pt mb-0" style="font-weight: 600; color: black">Capacidad</p>
      <p class="rubik-regular-12pt mb-0">{{ boat?.peopleMax || 0 }} pasajeros</p>
    </div>
  </div>
</div>

<div *ngIf="boat?.isEco" class="d-flex" style="border-top: 0.5px solid #cccccc; padding: 12px 2em">
  <div
    class="d-flex align-items-center"
    style="gap: 0.35em; height: 26px; padding: 0 12px; background-color: #1fb45b; border-radius: 50rem"
    [tooltip]="boat?.sustainabilityScore ? 'Puntaje de sostenibilidad: ' + boat.sustainabilityScore : ''"
    placement="bottom"
  >
    <span style="font-family: &quot;Rubik&quot;; font-size: 14px; font-weight: 500; color: #ffffff">eco</span>
    <i class="fas fa-leaf" style="font-size: 11px; color: #ffffff"></i>
  </div>
</div>
